import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import { getToken, setToken, clearToken, authApi } from '../api/client';

interface AuthContextValue {
  authed: boolean;
  login: (pin: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [authed, setAuthed] = useState(() => !!getToken());

  const login = useCallback(async (pin: string) => {
    const { token } = await authApi.login(pin);
    setToken(token);
    setAuthed(true);
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setAuthed(false);
    window.location.href = '/login';
  }, []);

  return (
    <AuthContext.Provider value={{ authed, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
